import { useQuery } from '@tanstack/react-query'
import type { ClaudeAccountList } from '@one-deployment/api'
import { get } from '@/lib/api'
import { qk } from '@/lib/query'

/** Every Claude account. Any member may see and pick them; the tokens never come back. */
export function useClaudeAccounts() {
  return useQuery({ queryKey: qk.claudeAccounts(), queryFn: ({ signal }) => get<ClaudeAccountList>('/api/claude-accounts', signal), staleTime: 30_000 })
}
